import { useParams } from 'react-router'
import { useSnapshot } from 'valtio'
import { ErrorDisplay } from '@/components/Error/Error'
import { Layout } from '@/components/Layout/Layout'
import { Loading } from '@/components/Loading/Loading'
import { RingList } from '@/components/RingList/RingList'
import { state } from '@/lib/state'
import type { Item } from '../../../../types'

export default function QuadrantPage() {
  const { isLoading, error, radarConfig, radarItems } = useSnapshot(state)
  const { quadrantId } = useParams()
  console.log('quadrant')
  if (isLoading || !radarConfig) {
    return (
      <Layout>
        <div className="flex items-center justify-center min-h-[calc(100vh-64px)]">
          <Loading />
        </div>
      </Layout>
    )
  }

  if (error) {
    return (
      <Layout>
        <div className="flex items-center justify-center min-h-[calc(100vh-64px)]">
          <ErrorDisplay error={error} />
        </div>
      </Layout>
    )
  }

  if (!quadrantId) {
    return (
      <Layout>
        <div className="flex items-center justify-center min-h-[calc(100vh-64px)]">
          <ErrorDisplay error={new Error('Quadrant ID is required')} />
        </div>
      </Layout>
    )
  }

  try {
    const quadrant = radarConfig.quadrants.find(q => q.id === quadrantId)
    const items = radarItems.filter(item => item.quadrant === quadrantId)
    const overviewLabel = radarConfig.labels.quadrantOverview

    if (!quadrant) {
      return (
        <Layout>
          <ErrorDisplay error={new Error(`Quadrant ${quadrantId} not found`)} />
        </Layout>
      )
    }

    return (
      <Layout>
        <div data-testid="quadrant-page">
          <div data-testid="quadrant-header">
            <div className="pb-5">
              <h1>{overviewLabel}</h1>
            </div>
            <div className="pb-3">
              <h2>{quadrant.title}</h2>
            </div>
          </div>
          <div data-testid="quadrant-content">
            <p>{quadrant.description}</p>
            <RingList items={items as Item[]} />
          </div>
        </div>
      </Layout>
    )
  } catch (err) {
    return (
      <Layout>
        <ErrorDisplay
          error={
            err instanceof Error ? err : new Error('Failed to load quadrant')
          }
        />
      </Layout>
    )
  }
}
